import { DefaultError } from "../constants/values";
import { ForbiddenError } from "../constants/values";
import { NetworkError } from "../constants/values";
import { DefaultTitleError } from "../constants/values";

const CODE_UNAUTHORIZED = 401;
const CODE_FORBIDDEN = 403;
const CODE_ERROR = 400;
const MSG_NETWORK_ERROR = "Network Error";

function handleMessage(error) {
  const { response } = error;

  const { status, data = {} } = response;

  switch (status) {
    case CODE_UNAUTHORIZED:
      return { messages: [""] };
    case CODE_FORBIDDEN:
      return { status, title: DefaultTitleError, messages: [ForbiddenError] };
    case CODE_ERROR:
      return {
        status,
        title: DefaultTitleError,
        messages: getMessageErrors(data),
      };
    default:
      const { errors = {}, title = DefaultTitleError } = data;
      const { messages = typeof (data) === 'string' ? data : [DefaultError] } = errors;
      return { status, title, messages };
  }
}

export function responseError(response) {
  try {
    const error = handleMessage(response);
    return Promise.reject(error);
  } catch {
    const { message } = response;
    let messageAlert = DefaultError;

    if (MSG_NETWORK_ERROR === message) messageAlert = NetworkError;

    const status = 500;
    const messages = [messageAlert];

    return Promise.reject({ status, title: DefaultTitleError, messages });
  }
}

export function getMessageErrors(errors) {
  if (!Array.isArray(errors)) {
    return typeof errors !== "string"
      ? ""
      : errors;
  }
  const errorMessages = errors.map((error) => error.errorMessage);
  const errorString = errorMessages.join("\n");

  return errorString;
}